import {th} from "vuetify/locale";

class FinancingModel {
    financingOptions
    selectedKey
    isFinancingAvailable

    constructor(financingOptions)
    {
        this.financingOptions = financingOptions.options
        this.selectedKey = financingOptions.default
        this.isFinancingAvailable = (Object.keys(this.financingOptions).length > 0)
    }

    getSelectedFinancing(grossAmount, netAmount)
    {
        if (this.selectedKey === 'cash') {
            return this.getFinancingCash()
        } else if (this.selectedKey === 'loan') {
            return this.getFinancingLoan(grossAmount)
        } else if (this.selectedKey === 'leasing') {
            return this.getFinancingLeasing(netAmount)
        }

        return {
            available: false
        }
    }

    getFinancingCash()
    {
        return {
            key: 'cash',
            available: false
        }
    }

    getFinancingLoan(amount)
    {
        const option = this.financingOptions['loan']

        let monthlyPayment = (option.interest * option.months * amount / 100 + amount ) /  option.months

        return {
            key: 'loan',
            available: true,
            months: option.months,
            title: option.title,
            monthlyPayment: monthlyPayment,
            finePrint: option.fine_print,
        }
    }

    getFinancingLeasing(amount)
    {
        amount = 0.65 * amount
        const option = this.financingOptions['leasing']

        let monthlyPayment = (option.interest * option.months * amount / 100 + amount ) /  option.months

        return {
            key: 'leasing',
            available: true,
            months: option.months,
            title: option.title,
            monthlyPayment: monthlyPayment,
            finePrint: option.fine_print,
        }
    }

}

export default FinancingModel
